module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/indi-store/details/store-details.component.css
// module id = ./src/app/indi-store/details/store-details.component.css
// module chunks = main